// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-divider.p-divider::before,
.client-divider.p-divider::after {
  border-top: 1px solid var(--primary-color) !important;
}

.client-divider {
  margin-left: 5rem;
  width: 90%;
}

.new-request-container {
  margin-top: 3rem !important;
}

@media (min-width: 768px) {
  .new-request-container {
    /* On screens >= 768px, set width to 50% */
    justify-self: center;
    width: 50%;
  }
}
.client-datatable th {
  background-color: var(--primary-color);
}

.client-datatable {
  .p-sortable-column-icon {
    color: white;
  }
  .p-column-title {
    color: white !important;
  }
}

button.p-button-primary[aria-label=Upload] {
  display: none;
}

.p-button-primary {
  background-color: var(--primary-color);
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/client_zone/message/contract-page.css"],"names":[],"mappings":"AAAA;;EAEE,qDAAA;AACF;;AAEA;EACE,iBAAA;EACA,UAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE;IACE,0CAAA;IACA,oBAAA;IACA,UAAA;EACF;AACF;AAEA;EACE,sCAAA;AAAF;;AAGA;EACE;IACE,YAAA;EAAF;EAGA;IACE,uBAAA;EADF;AACF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,sCAAA;AADF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
